<!--
  @Description: 找公司
  @Author: wang.y 
  @Date: 2022-02-14
 * @LastEditTime: 2022-04-25 10:52:25
 * @LastEditors: lan.h
-->
<template>
  <div class="first-container">
    <!-- <div class="prompt-content">
      <p>动脉网PC3.0抢先体验：7*24小时情报追踪、结构化认知医疗行业大事、医疗产业资源对接等，<a :href="$store.state.index2_path + '/new'">立即体验</a></p>
    </div> -->
    <!-- <div class="prompt-content">
      <p>NEW！动脉网全新域名</p>
      <a>https://www.vbdata.cn</a>
      <p>正式启用，原网址仍支持访问</p>
    </div> -->
    <div class="company-filter">
      <DataNavigation ref="data-nav"></DataNavigation>
      <div class="comp-container">
        <Spin v-if="loading" class="comp-spin" fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <!-- 热点观察 -->
        <div class="container-title">
          <div class="lf">热点观察</div>
          <div class="rt">
            <span>热点观察数据由</span>
            <img class="logo" :src="static_img_url+'pic/logo.png'" @click="haddleApplyTry2(32)" />
            <span>提供支持</span>
          </div>
        </div>
        <div class="hot-ob">
          <div class="comp-fina">
            <div class="line"></div>
            <DFinancing :showMore="false" pageType="2"></DFinancing>
          </div>
          <div class="fina-hot">
            <div class="title">
              融资热点
              <div class="line"></div>
              <div class="lookmore" @click="handleHotMore">查看更多</div>
            </div>
            <div class="popular-bg">
              <img :src="static_img_url+'pic/comp-bg.png'" />
              <div class="popular">
                <div class="tagcloud">
                  <span v-for="item,index in hot_tag" :key="index" :style="{'font-size': tag_font(index)}" @click="handleClickTag(item)">{{item.tagName}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="hot-theme">
            <Spin fix v-if="theme_loading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
            <div class="li" v-for="item,index in hot_list" :key="index">
              <img class="mask" :src="$store.state.static_img_url+'pic/vcbeat/mask.png'" />
              <div class="title">
                <i class="iconfont lf">&#xe6a8;</i>
                <div class="cnt over-p3">{{item.title}}</div>
              </div>
              <div class="collect">
                <i class="iconfont on" title="取消收藏" v-if="item.isCollect" @click="cancelCollect(contentType(item.contentType), item.id, delCollectCb, index)" onclick="_czc.push(['_trackEvent', '找公司(新)', '热点观察(专题/文章的收藏/取消收藏)', '点击量'])">&#xe66f;</i>
                <i class="iconfont" title="收藏" v-else @click="addCollect(contentType(item.contentType), item.id, addCollectCb,index)" onclick="_czc.push(['_trackEvent', '找公司(新)', '热点观察(专题/文章的收藏/取消收藏)', '点击量'])">&#xe66f;</i>
              </div>
              <div class="desc">
                <div class="cnt over-p4" @click="toThemePro(item.contentType, item)">{{item.summary}}</div>
                <div class="look" @click="toThemePro(item.contentType, item)">查看详情</div>
                <a :href="item.contentType == 2 ? $store.state.index_path + '/specialDetail/' + item.uid : $store.state.index2_path + '/' + item.id"></a>
              </div>
              <img class="bgimg" :src="item.coverImgPath | logo_show" />
            </div>
          </div>
        </div>
        <!-- 早期项目发掘机 -->
        <common-template :temp="1">
          <theme-swiper slot="theme" :temp="1" :data="new_project_list" colType="1"></theme-swiper>
          <flow-list slot="list" :data="new_project_dynamic" colType="1"></flow-list>
          <comp-table slot="data" :data="event_list1" colType="1"></comp-table>
          <span class="lk-btn" slot="list-lk-btn" @click="goToMore(2)" onclick="_czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(动态信息流的查看更多)', '点击量'])">查看更多</span>
          <span class="lk-btn" slot="data-lk-btn" @click="goToEvent(2)" onclick="_czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(融资项目的查看更多)', '点击量'])">查看更多</span>
        </common-template>
        <!-- 未来头条公司 -->
        <common-template :temp="2">
          <theme-swiper slot="theme" :temp="2" :data="future_top_list" colType="2"></theme-swiper>
          <flow-list slot="list" :data="future_top_dynamic" colType="2"></flow-list>
          <comp-table slot="data" :data="event_list2" colType="2"></comp-table>
          <span class="lk-btn" slot="list-lk-btn" @click="goToMore(3)" onclick="_czc.push(['_trackEvent', '找公司(新)', '未来头条公司(动态信息流的查看更多)', '点击量'])">查看更多</span>
          <span class="lk-btn" slot="data-lk-btn" @click="goToEvent(3)" onclick="_czc.push(['_trackEvent', '找公司(新)', '未来头条公司(融资项目的查看更多)', '点击量'])">查看更多</span>
        </common-template>
        <!-- 活跃机构领域版图 -->
        <common-template :temp="3">
          <theme-swiper slot="theme" :temp="3" :data="active_agency_list" colType="3"></theme-swiper>
          <flow-list slot="list" :data="active_agency_dynamic" colType="3"></flow-list>
          <org-table slot="data" :data="org_top_list" colType="3"></org-table>
          <span class="lk-btn" slot="list-lk-btn" @click="goToMore(4)" onclick="_czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(动态信息流的查看更多)', '点击量'])">查看更多</span>
          <span class="lk-btn" slot="data-lk-btn" @click="goToEvent(4)" onclick="_czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(活跃机构的查看更多)', '点击量'])">查看更多</span>
        </common-template>
        <!-- 科技巨头投资版图 -->
        <common-template :temp="4">
          <theme-swiper slot="theme" :temp="4" :data="technology_top_list" colType="4"></theme-swiper>
          <flow-list slot="list" :data="technology_top_dynamic" colType="4"></flow-list>
          <CompanySankey :cItem="tct" :meta="meta" slot="data" v-if="tct"></CompanySankey>
          <span class="lk-btn" slot="list-lk-btn" @click="goToMore(5)" onclick="_czc.push(['_trackEvent', '找公司(新)', '科技巨头投资版图(动态信息流的查看更多)', '点击量'])">查看更多</span>
          <Select class="sankey-select" v-model="sankey_active_id" slot="data-lk-btn" @on-change="handleChangeSankey">
            <Option v-for="item in meta.getvbdatacomp" :value="item.tct_id" :key="item.tct_id">{{ item.name }}</Option>
          </Select>
        </common-template>
        <!-- 公司数据库 -->
        <div class="container-title">
          <div class="lf">公司数据库</div>
          <div class="rt">
            <span>公司数据库数据由</span>
            <img class="logo" :src="static_img_url+'pic/logo.png'" @click="haddleApplyTry2(32)">
            <span>提供支持</span>
          </div>
        </div>
        <CompList ref="comp-list"></CompList>
      </div>
    </div>
  </div>
</template>
<script>
import DataNavigation from '@/components/DataNavigation'
import CommonTemplate from './components/CommonTemplate'
import ThemeSwiper from './components/ThemeSwiper'
import FlowList from './components/FlowList'
import CompTable from './components/CompTable'
import OrgTable from './components/OrgTable'
import CompList from './components/CompList'
import CompanySankey from './components/CompanySankey'
import DFinancing from '@/components/vcbeat/DFinancing.vue'
import filter from 'js/filter'
import { collect_mixin } from 'js/collect_mixin'
import {
  getThemetop,
  eventHotTag,
  companyDynamic,
  getMeta,
  orgTop,
  eventList,
  getTctData,
} from '@/service.js'
export default {
  inject: ['haddleApplyTry2'],
  mixins: [collect_mixin],
  components: {
    DataNavigation,
    CommonTemplate,
    ThemeSwiper,
    FlowList,
    CompTable,
    OrgTable,
    CompList,
    DFinancing,
    CompanySankey,
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
    tag_font() {
      return function (index) {
        if (index == 0) {
          return '24px'
        } else if (index > 0 && index < 3) {
          return '20px'
        } else if (index >= 3 && index < 6) {
          return '18px'
        } else {
          return '14px'
        }
      }
    },
    contentType() {
      return function (type) {
        return type == '1' ? '4' : type
      }
    },
  },
  data() {
    return {
      new_project_list: [], //公司置顶专题列表
      hot_list: [], //热点观察
      future_top_list: [], //未来头条公司
      active_agency_list: [], //活跃机构
      technology_top_list: [], //科技巨头
      hot_tag: [], //热词
      new_project_dynamic: [], //早期项目发掘机-动态
      future_top_dynamic: [], //未来头条公司-动态
      active_agency_dynamic: [], //活跃机构-动态
      technology_top_dynamic: [], //科技巨头-动态
      loading: true,
      entity_ntag: [],
      org_top_list: [], //活跃机构列表
      event_list1: [], //早期项目发掘机-融资项目列表
      event_list2: [], //未来头条公司-融资项目列表
      sankey_active_id: '',
      tct: '',
      meta: '',
      dynamic_loading: true,
      orgtop_loading: true,
      theme_loading: true,
      event_loading: true,
    }
  },
  created() {
    this.companyDynamic()
    this.orgTop()
    this.getThemetop()
    this.eventList()
    Promise.all([
      new Promise((resolve) => {
        this.getMeta(resolve)
      }),
      new Promise((resolve) => {
        this.eventHotTag(resolve)
      }),
    ]).then((res) => {
      this.loading = false
    })
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        this.$refs['data-nav'].scrollChange()
        this.$refs['comp-list'].scrollcContrast()
      }, 10)
    })
  },
  beforeDestroy() {
    window.onscroll = ''
  },
  methods: {
    /**
     * @description: 滚动条防抖
     * @param {*} fn
     * @param {*} wait
     * @return {*}
     */
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    addCollectCb(index) {
      this.hot_list[index].isCollect = true
    },
    delCollectCb(index) {
      this.hot_list[index].isCollect = false
    },
    async getMeta(resolve) {
      let res = await getMeta(
        { name: ['entity_ntag', 'getvbdatacomp', 'tct_business_nature', 'tct_business_nature'] },
        (error) => {
          this.$Message.error('元数据请求错误！')
        }
      )
      resolve(res)
      if (res.status == 'success') {
        this.$set(this.$data, 'meta', res.meta)
        this.entity_ntag = res.meta.entity_ntag
        this.sankey_active_id = res.meta.getvbdatacomp[0].tct_id
        this.getTctData(res.meta.getvbdatacomp[0].tct_id, res.meta.getvbdatacomp[0].theme_uid)
      }
    },
    /**
     * 科技巨头桑基图
     */
    async getTctData(tct_id, theme_uid) {
      let res = await getTctData(
        {
          tct_id: tct_id,
          theme_uid: theme_uid,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'tct', res.tct[0])
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 修改桑基图
     */
    handleChangeSankey(tct_id) {
      let theme_uid = filter.dealName(tct_id, this.meta.getvbdatacomp, 'tct_id', 'theme_uid')
      this.tct = ''
      this.getTctData(tct_id, theme_uid)
      _czc.push(['_trackEvent', '找公司(新)', '科技巨头投资版图(科技巨头的切换标签)', '点击量'])
    },
    //公司置顶专题列表
    async getThemetop(resolve) {
      let res = await getThemetop(
        {
          userKey: this.$store.state.user_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      // resolve(res)
      this.theme_loading = false
      if (res.code == 0) {
        let data = res.data.companyThemeCategories
        //热点观察
        this.hot_list = data.find((a) => a.id == 1)['companyThemes'] || []
        //早期项目发掘机
        this.new_project_list = data.find((a) => a.id == 2)['companyThemes'] || []
        //未来头条公司
        this.future_top_list = data.find((a) => a.id == 3)['companyThemes'] || []
        //活跃机构领域版图
        this.active_agency_list = data.find((a) => a.id == 4)['companyThemes'] || []
        //科技巨头投资版图
        this.technology_top_list = data.find((a) => a.id == 5)['companyThemes'] || []
      } else {
        this.$Message.error(res.msg)
      }
    },
    //融资热点-词云
    async eventHotTag(resolve) {
      let res = await eventHotTag((error) => {
        this.$Message.error('请求错误！')
      })
      resolve(res)
      if (res.code == 0) {
        this.hot_tag = res.data
        this.$nextTick(() => {
          tagcloud({
            selector: '.tagcloud',
            fontsize: 24,
            radius: 70,
            mspeed: 'normal',
            ispeed: 'normal',
            direction: 135,
            keep: false,
          })
        })
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取公司动态
    async companyDynamic(resolve) {
      //早期项目发掘机-动态
      let res2 = await companyDynamic({ categoryId: 2, size: 20, queryType: 1 }, (error) => {
        this.$Message.error('请求错误！')
      })
      //未来头条公司-动态
      let res3 = await companyDynamic({ categoryId: 3, size: 20, queryType: 1 }, (error) => {
        this.$Message.error('请求错误！')
      })
      //活跃机构领域版图-动态
      let res4 = await companyDynamic({ categoryId: 4, size: 20, queryType: 1 }, (error) => {
        this.$Message.error('请求错误！')
      })
      //科技巨头-动态
      //活跃机构领域版图-动态
      let res5 = await companyDynamic({ categoryId: 5, size: 20, queryType: 1 }, (error) => {
        this.$Message.error('请求错误！')
      })
      // resolve({
      //   res2: res2,
      //   res3: res3,
      //   res4: res4,
      //   res5: res5
      // })
      this.dynamic_loading = false
      if (res2.code == 0) {
        this.new_project_dynamic = res2.data
        this.dealTraks(this.new_project_dynamic)
      }
      if (res3.code == 0) {
        this.future_top_dynamic = res3.data
        this.dealTraks(this.future_top_dynamic)
      }
      if (res4.code == 0) {
        this.active_agency_dynamic = res4.data
        this.dealTraks(this.active_agency_dynamic)
      }
      if (res5.code == 0) {
        this.technology_top_dynamic = res5.data
        this.dealTraks(this.technology_top_dynamic)
      }
    },
    //活跃机构
    async orgTop(resolve) {
      let res = await orgTop({ size: 4 }, (error) => {
        this.$Message.error('请求错误！')
      })
      // resolve(res)
      this.orgtop_loading = false
      if (res.status == 'success') {
        this.org_top_list = res.res.slice(0, 4)
        this.org_top_list.map((item) => {
          let focus = [] //关注领域
          let tags = item.tags.split(',')
          tags.map((t) => {
            let index = this.$store.state.dynview_tag.findIndex((o) => o.id == t)
            if (index > -1) {
              focus.push(this.$store.state.dynview_tag[index])
            }
          })
          this.$set(item, 'focus', focus)
        })
      } else {
        this.$Message.error(res.message)
      }
    },
    //融资项目
    async eventList(resolve) {
      let res1 = await eventList({ page: 1, round_id: [1, 2, 3, 5, 4] }, (error) => {
        this.$Message.error('请求错误！')
      })
      let res2 = await eventList({ page: 1 }, (error) => {
        this.$Message.error('请求错误！')
      })
      this.event_loading = false
      // resolve({
      //   res1: res1,
      //   res2: res2
      // })
      if (res1.status == 'success') {
        this.event_list1 = res1.res.slice(0, 4)
      }
      if (res2.status == 'success') {
        this.event_list2 = res2.res.slice(0, 4)
      }
    },
    handleClickTag(item) {
      const href1 = this.$store.state.index_path + '/financing?fromPath=tagcloud'
      window.open(href1, '_blank')
    },
    dealTraks(list) {
      list.map((item) => {
        let entity_tag = []
        item.tracks.map((tag) => {
          let index = this.entity_ntag.findIndex((o) => o.id == tag)
          if (index > -1) {
            entity_tag.push(this.entity_ntag[index])
          }
        })
        this.$set(item, 'entity_tag', entity_tag)
      })
    },
    goToMore(id) {
      const { href } = this.$router.resolve({ name: 'CompanyMore', query: { categoryId: id } })
      window.open(href, '_blank')
    },
    //跳转至事件列表
    goToEvent(id) {
      switch (id) {
        case 2:
        case 3:
          const { href } = this.$router.resolve({ name: 'EventList' })
          window.open(href, '_blank')
          break
        case 4:
          const href1 = this.$store.state.index_path + '/financing?fromPath=company'
          window.open(href1, '_blank')
          break
      }
    },
    //跳转至专题pro
    toThemePro(type, item) {
      if (type == 2) {
        const { href } = this.$router.resolve({ name: 'SpecialDetail', params: { uid: item.uid } })
        window.open(href, '_blank')
      } else if (type == 1) {
        const temp_href = this.$store.state.index2_path + '/' + item.id
        window.open(temp_href, '_blank')
      }
      _czc.push(['_trackEvent', '找公司(新)', '热点观察(专题/文章的标题)', '点击量'])
    },
    handleHotMore() {
      const { href } = this.$router.resolve({
        name: 'FinancingIndex',
        query: { fromPath: 'tagcloud' },
      })
      window.open(href, '_blank')
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
.first-container
  background #fff
  display flex
  flex-direction column
.prompt-content
  width 100%
  height 28px
  background #FFECDC
  display flex
  justify-content center
  align-items center
  position fixed
  top 64px
  z-index 100
  p
    font-size 12px
    color #FA5A00
    a
      color #3652FF
      cursor pointer
.company-filter
  background #fff
  display flex
  justify-content center
  min-width 1200px
  position relative
.comp-container
  margin-left 20px
  width 1090px
  padding-bottom 40px
  position relative
  >>> .container-title
    padding 30px 0 20px
    display flex
    justify-content space-between
    .lf
      font-size 20px
      color #333333
      position relative
      line-height 1
      z-index 1
      padding-bottom 2px
      &::before
        content ''
        position absolute
        background rgba(255, 186, 128, 1)
        height 6px
        width 100%
        bottom -1px
        z-index -1
    .rt
      display flex
      align-items center
      font-size 12px
      color #999999
      line-height 1
      .logo
        height 16px
        margin 0 3px
        cursor pointer
  .hot-ob
    display flex
    > div
      width 354px
      height 260px
      background #F8F9FA
      &+div
        margin-left 14px
    .comp-fina
      padding 12px
      position relative
      .line
        position absolute
        width 162px
        height 1px
        background #E9E9E9
        right 12px
        top 20px
    .hot-theme
      display grid
      grid-template-columns 172px 172px
      grid-template-rows 125px 125px
      grid-gap 10px
      background none
      position relative
      .li
        position relative
        overflow hidden
        cursor pointer
        .mask
          position absolute
          width 100%
          height 100%
          top 0
          left 0
          z-index 1
        .bgimg
          position absolute
          width 100%
          height 100%
          top 0
          left 0
          z-index 0
        .title
          display flex
          position absolute
          z-index 2
          top 10px
          left 4px
          .lf
            color #FA5A00
            font-size 16px
            line-height 20px
          .cnt
            width 112px
            font-size 14px
            font-family PingFang SC
            font-weight 500
            color #FFFFFF
            line-height 20px
            // text-shadow 0px 3px 7px #000000
        &:hover
          transition all 0.5s
          .desc
            transform translateY(0)
            opacity 1
        .collect
          position absolute
          z-index 4
          right 10px
          top 10px
          width 16px
          height 16px
          background #F3F3F3
          border-radius 4px
          display flex
          justify-content center
          align-items center
          margin 2px 0 0 12px
          cursor pointer
          .iconfont
            font-size 12px
            color #CCCCCC
            &.on
              color #FA5A00
        .desc
          transition all 0.5s
          transform translateY(100%)
          opacity 0.6
          position absolute
          z-index 3
          top 0
          left 0
          width 100%
          height 100%
          background rgba(0, 0, 0, 0.6)
          padding 15px 35px 0 15px
          .cnt
            font-size 13px
            color #FFFFFF
            line-height 18px
            cursor pointer
            &:hover
              color #FA5A00
          .look
            cursor pointer
            position absolute
            bottom 12px
            right 15px
            color #FA5A00
            font-size 12px
    .fina-hot
      padding-top 12px
      .title
        font-size 16px
        font-weight 500
        color #333333
        line-height 1
        padding 0 12px
        display flex
        justify-content space-between
        align-items center
        .line
          margin-left 10px
          flex 1
          height 1px
          background #E9E9E9
        .lookmore
          cursor pointer
          color #FA5A00
          font-size 14px
          margin-left 10px
      .popular-bg
        margin-top 14px
        height 218px
        width 354px
        position relative
        .popular
          height 100%
          width 100%
          position absolute
          top 0
          left 0
          z-index 3
          overflow hidden
          .tagcloud
            height 100%
            width 100%
            span
              position absolute
              top 0
              left 0
              color #FA5A00
              cursor pointer
      img
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
  >>> .sankey-select
    width 100px
    .ivu-select-selection
      border-radius 0
  >>>.ivu-spin
    color #FA5A00
    &.comp-spin
      z-index 10
      .ivu-spin-main
        top 300px
</style>